exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".szx2I0wECipFBS1JALZqH{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}html[dir] .szx2I0wECipFBS1JALZqH{margin-top:48px}", ""]);
// Exports
exports.locals = {
	"container": "szx2I0wECipFBS1JALZqH"
};